const pageDown = document.querySelectorAll(".page-down");

for (let i = 0; i < pageDown.length; i++) {
  pageDown[i].addEventListener("click", function (event) {
    let siblingDiv = this.closest("section").nextElementSibling;
    if (siblingDiv) {
      siblingDiv.scrollIntoView();
    } else {
      return false;
    }
  });
}
